import {
  isOnboardingFinished,
  shouldShowOnboarding,
} from '../lib/onboardingGate';
import { useMember } from './useMember';
import { usePagedList } from './usePagedList';

/**
 * Whether the new shell should open setup: the old shell's rule
 * (shouldShowOnboarding), for an owner whose company has no driver but
 * them and no call yet, until setup is finished or skipped on this device.
 * The two lists are read only for an owner who has not.
 */
export function useSetupDue(): boolean {
  const member = useMember();
  const owner = member.officeRole === 'OWNER';
  const finished = isOnboardingFinished();
  const enabled = owner && !finished && !member.isLoading;
  const drivers = usePagedList('setup-drivers', '/drivers', {}, { enabled });
  const calls = usePagedList('setup-calls', '/calls', {}, { enabled });
  return shouldShowOnboarding({
    hasDriverId: true,
    hasCompanyId: Boolean(member.membership),
    isFetchingUserCompanies: member.isLoading,
    isOwner: owner,
    companyDriversLoading: drivers.isLoading,
    dispatchesLoading: calls.isLoading,
    // A new company's owner drives too, so they are not counted.
    otherDriversCount: Math.max(
      0,
      (drivers.meta?.totalCount ?? 0) - (member.drives ? 1 : 0)
    ),
    dispatchesCount: calls.meta?.totalCount ?? 0,
    onboardingCompleted: finished,
  });
}
